import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from '@mui/material';

const PropertyDeleteDialog = ({open, property, saving, onCancel, onConfirm}) => {
    const propertyName = property?.propertyLabel || property?.propertyId || property?.propertyItemId;

    return (
        <Dialog open={open} onClose={saving ? undefined : onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>Delete property</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete {propertyName ? `"${propertyName}"` : 'this property'}?
                    This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={saving}>Cancel</Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={saving}>
                    {saving ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PropertyDeleteDialog;

